// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file accounts/update_my_settings.proto (package protos.accounts, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { FieldMask } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_field_mask } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file accounts/update_my_settings.proto.
 */
export const file_accounts_update_my_settings: GenFile = /*@__PURE__*/
  fileDesc("CiFhY2NvdW50cy91cGRhdGVfbXlfc2V0dGluZ3MucHJvdG8SD3Byb3Rvcy5hY2NvdW50cyLTAgoXVXBkYXRlTXlTZXR0aW5nc1JlcXVlc3QSPwoGcGFyYW1zGAEgASgLMi8ucHJvdG9zLmFjY291bnRzLlVwZGF0ZU15U2V0dGluZ3NSZXF1ZXN0LlBhcmFtcxIvCgt1cGRhdGVfbWFzaxgCIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5GaWVsZE1hc2saxQEKBlBhcmFtcxIuCiZub3RpZmljYXRpb25zX3B1c2hfbmV3X2pvYl9hcHBsaWNhdGlvbhgBIAEoCBIvCidub3RpZmljYXRpb25zX3B1c2hfY29ubmVjdGlvbl9yZXF1ZXN0ZWQYAiABKAgSLgombm90aWZpY2F0aW9uc19wdXNoX2Nvbm5lY3Rpb25fYWNjZXB0ZWQYAyABKAgSKgoibm90aWZpY2F0aW9uc19wdXNoX21lc3NhZ2VfY3JlYXRlZBgEIAEoCCJmChhVcGRhdGVNeVNldHRpbmdzUmVzcG9uc2USQAoGcmVzdWx0GAEgASgLMjAucHJvdG9zLmFjY291bnRzLlVwZGF0ZU15U2V0dGluZ3NSZXNwb25zZS5SZXN1bHQaCAoGUmVzdWx0YgZwcm90bzM", [file_google_protobuf_field_mask]);

/**
 * @generated from message protos.accounts.UpdateMySettingsRequest
 */
export type UpdateMySettingsRequest = Message<"protos.accounts.UpdateMySettingsRequest"> & {
  /**
   * @generated from field: protos.accounts.UpdateMySettingsRequest.Params params = 1;
   */
  params?: UpdateMySettingsRequest_Params | undefined;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 2;
   */
  updateMask?: FieldMask | undefined;
};

/**
 * Describes the message protos.accounts.UpdateMySettingsRequest.
 * Use `create(UpdateMySettingsRequestSchema)` to create a new message.
 */
export const UpdateMySettingsRequestSchema: GenMessage<UpdateMySettingsRequest> = /*@__PURE__*/
  messageDesc(file_accounts_update_my_settings, 0);

/**
 * @generated from message protos.accounts.UpdateMySettingsRequest.Params
 */
export type UpdateMySettingsRequest_Params = Message<"protos.accounts.UpdateMySettingsRequest.Params"> & {
  /**
   * @generated from field: bool notifications_push_new_job_application = 1;
   */
  notificationsPushNewJobApplication: boolean;

  /**
   * @generated from field: bool notifications_push_connection_requested = 2;
   */
  notificationsPushConnectionRequested: boolean;

  /**
   * @generated from field: bool notifications_push_connection_accepted = 3;
   */
  notificationsPushConnectionAccepted: boolean;

  /**
   * @generated from field: bool notifications_push_message_created = 4;
   */
  notificationsPushMessageCreated: boolean;
};

/**
 * Describes the message protos.accounts.UpdateMySettingsRequest.Params.
 * Use `create(UpdateMySettingsRequest_ParamsSchema)` to create a new message.
 */
export const UpdateMySettingsRequest_ParamsSchema: GenMessage<UpdateMySettingsRequest_Params> = /*@__PURE__*/
  messageDesc(file_accounts_update_my_settings, 0, 0);

/**
 * @generated from message protos.accounts.UpdateMySettingsResponse
 */
export type UpdateMySettingsResponse = Message<"protos.accounts.UpdateMySettingsResponse"> & {
  /**
   * @generated from field: protos.accounts.UpdateMySettingsResponse.Result result = 1;
   */
  result?: UpdateMySettingsResponse_Result | undefined;
};

/**
 * Describes the message protos.accounts.UpdateMySettingsResponse.
 * Use `create(UpdateMySettingsResponseSchema)` to create a new message.
 */
export const UpdateMySettingsResponseSchema: GenMessage<UpdateMySettingsResponse> = /*@__PURE__*/
  messageDesc(file_accounts_update_my_settings, 1);

/**
 * @generated from message protos.accounts.UpdateMySettingsResponse.Result
 */
export type UpdateMySettingsResponse_Result = Message<"protos.accounts.UpdateMySettingsResponse.Result"> & {
};

/**
 * Describes the message protos.accounts.UpdateMySettingsResponse.Result.
 * Use `create(UpdateMySettingsResponse_ResultSchema)` to create a new message.
 */
export const UpdateMySettingsResponse_ResultSchema: GenMessage<UpdateMySettingsResponse_Result> = /*@__PURE__*/
  messageDesc(file_accounts_update_my_settings, 1, 0);

